import { Scene } from "@babylonjs/core/scene";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Animation } from "@babylonjs/core/Animations/animation";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { BOX_FALL_FRAMES } from "./constants";

// 箱の落下アニメ：前方 1 マスへ XZ 移動 → 急降下。アニメ完了後に dispose。
// stopAtY 指定時は y がそこに到達したら停止（海ブロック上で止まる用）。
// 未指定時は y - 8 まで急降下（虚無への落下）。
// speedRatio: アニメ速度倍率（デフォルト 1.0）
export const performBoxFall = (
  scene: Scene,
  node: AbstractMesh,
  fwd: { dx: number; dz: number },
  opts?: { stopAtY?: number },
  speedRatio = 1,
): Promise<void> =>
  new Promise<void>((resolve) => {
    if (!scene || scene.isDisposed) {
      node.dispose();
      return resolve();
    }
    const start = node.position.clone();
    const TILE = 2;
    const endY = opts?.stopAtY !== undefined ? opts.stopAtY : start.y - 8;

    const anim = new Animation(
      "boxFall",
      "position",
      BOX_FALL_FRAMES,
      Animation.ANIMATIONTYPE_VECTOR3,
      Animation.ANIMATIONLOOPMODE_CONSTANT,
    );
    anim.setKeys([
      { frame: 0, value: start.clone() },
      {
        frame: 2,
        value: new Vector3(start.x + fwd.dx * TILE * 0.5, start.y, start.z + fwd.dz * TILE * 0.5),
      },
      {
        frame: BOX_FALL_FRAMES,
        value: new Vector3(start.x + fwd.dx * TILE, endY, start.z + fwd.dz * TILE),
      },
    ]);
    const a = scene.beginDirectAnimation(node, [anim], 0, BOX_FALL_FRAMES, false, speedRatio);
    a.onAnimationEnd = () => {
      node.dispose();
      resolve();
    };
  });
